/********** 12Tshirts**********/
  /***** adobefont *****/
    (function(d) {
      var config = {
        kitId: 'wqa4aqs',
        scriptTimeout: 3000,
        async: true
      },
      h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
    })(document);
  /***** /adobefont *****/

  /***** a no link *****/
    $(function(){
        $('a.nolink').on('click', function() {
          return false;
        });
    });
  /***** /a no link *****/

  /***** hero *****/
    jQuery(function(){
      $(".thum img").click(function(){
        url = $(this).attr('src');
        id = $(this).parents('ul').attr('id');
        $('#' + id + " .mainImg img").attr('src', url).css({'display': 'none'}).fadeIn(1000);
      });
    });

    jQuery(function(){
      $(".thum img").one("click", function() {
        $('.mainImg > figure > a').zoom();
        $('.mainImg > figure').zoom();
      });
    });

    jQuery(function(){
      if (window.matchMedia("(max-width: 768px)").matches) {
        $("section#hero > figure:first-child").hide().fadeIn(1000).delay(100).animate({ top:'-1%' }, 700, 'swing');
      } else {
        $("section#hero > figure:first-child").hide().fadeIn(1000).delay(100).animate({ top:'-1.1%' }, 700, 'swing');
      };
    });
  /***** /hero *****/

  /***** tab *****/      
    jQuery(function($){
      $('.month01.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#jan.list').removeClass('hide');
      });
      /* $('.month02.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#feb.list').removeClass('hide');
      });
      $('.month03.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#mar.list').removeClass('hide');
      });
      $('.month04.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#apl.list').removeClass('hide');
      });
      $('.month05.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#may.list').removeClass('hide');
      });
      $('.month06.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#jun.list').removeClass('hide');
      });
      $('.month07.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#jul.list').removeClass('hide');
      });
      $('.month08.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#aug.list').removeClass('hide');
      });
      $('.month09.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#sep.list').removeClass('hide');
      });
      $('.month10.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#oct.list').removeClass('hide');
      });
      $('.month11.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#nov.list').removeClass('hide');
      });
      $('.month12.tabbtn').click(function(){
        $('.list').addClass('hide');
        $('#dec.list').removeClass('hide');
      }); */

      /* クラス毎月追加 */
      $('.month01.tabbtn').click(function(){;
        var heroW = $('#hero').outerWidth();
        // var scrollTop = main.scrollTop;
        var pos = heroW * 0.28
        var posSp = 200
        if (window.matchMedia("(max-width: 768px)").matches) {
          $('body,html').animate({
            scrollTop: posSp
          }, 300, 'swing');
          return false;
        } else {
          $('body,html').animate({
            scrollTop: pos
          }, 300, 'swing');
          return false;
        };
      });

      /* $(function () {
        var headH = $("header").outerHeight();
        var animeSpeed = 500;
        $(".tabbtn a[href^='#']").on({
          "click": function () {
            var href = $(this).attr("href");
            var target = $(href == "#" || href === "" ? "html" : href);
            var position;
            position = target.offset().top - headH;
            $("body,html").stop().animate({ scrollTop: position }, animeSpeed);
            return false;
          }
        });
      }); */


    });
  /***** /tab *****/

  /***** slick *****/
    $(document).ready(function(){
      $('ul#month').slick({
        autoplay: false,
        autoplay: true,
        autoplaySpeed: 4000,
        // centerMode: true,
        // centerPadding: '8%',
        cssEase: 'cubic-bezier(0.5,-1,0.5,2)',
        // easing: 'easeOutBounce',
        initialSlide: 0,
        slidesToShow: 3,
        speed: 1000,
        responsive: [{
          breakpoint: 812,
          settings: {
            slidesToShow:2
          }
        }]
      });
    });
  /***** /slick *****/

  /***** modal *****/
    $(function(){
      var modal = $('.slick-slide img');
      modal.on('click', function(){
        var imgPath = $(this).prop('outerHTML');
        $('#over').fadeIn(500);
        $('#modal').fadeIn(1000).html(imgPath+'<i class="fas fa-times-circle" id="close"></i>');
      });
      $('#over, #close').on('click', function(){
        $('#over').fadeOut(500);
        $('#modal').fadeOut(100);
      });
    });
  /***** /modal *****/

  /***** timer *****/
    $(document).ready(function() {
      $(".view_timer").each(function(index, target) {
        var startDate = $(this).attr("data-startdate");
        var endDate = $(this).attr("data-enddate");
        var nowDate = new Date();
        if (startDate) {
          startDate = new Date(startDate);
        } else {
          startDate = nowDate;
        }
        if (endDate) {
          endDate = new Date(endDate);
        }
        if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
          $(this).addClass('nolink');
        } else {
          $(this).removeClass('nolink');
        }
      });
    });

    $(document).ready(function() {
      $(".show_timer").each(function(index, target) {
        var startDate = $(this).attr("data-startdate");
        var endDate = $(this).attr("data-enddate");
        var nowDate = new Date();
        if (startDate) {
          startDate = new Date(startDate);
        } else {
          startDate = nowDate;
        }
        if (endDate) {
          endDate = new Date(endDate);
        }
        if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
          $(this).show();
          // $('.mainImg > figure').zoom();
        } else {
          $(this).hide();
          $('.mainImg > figure:hover').css({'cursor': 'pointer'});
          // $('.mainImg > figure > a').zoom();
          // var clickEventType=((window.ontouchend!==null)?'click':'touchend');


          // 毎月追加
          linkjan = $('#jan > .mainImg > figure.pointer') 
          // linkjan.on( clickEventType, function(){ location.href = '/products/anxz-26290-anxz-26291-anxz-26292'; });
          linkjan.on('click', function(){ location.href = '/products/anxz-26290-anxz-26291-anxz-26292'; });
          $(function () {
            $(linkjan).longpress(function (e) {
              return false;
            },
              function () {
                  location.href = '/products/anxz-26290-anxz-26291-anxz-26292';                },
              500 
            );
          });
          linkfeb = $('#feb > .mainImg > figure.pointer') 
          linkfeb.on('click', function(){ location.href = ''; });
          linkmar = $('#mar > .mainImg > figure.pointer') 
          linkmar.on('click', function(){ location.href = ''; });
          linkapl = $('#apl > .mainImg > figure.pointer') 
          linkapl.on('click', function(){ location.href = ''; });
          linkmay = $('#may > .mainImg > figure.pointer') 
          linkmay.on('click', function(){ location.href = ''; });
          linkjun = $('#jun > .mainImg > figure.pointer') 
          linkjun.on('click', function(){ location.href = ''; });
          linkjul = $('#jul > .mainImg > figure.pointer') 
          linkjul.on('click', function(){ location.href = ''; });
          linkaug = $('#aug > .mainImg > figure.pointer') 
          linkaug.on('click', function(){ location.href = ''; });
          linksep = $('#sep > .mainImg > figure.pointer') 
          linksep.on('click', function(){ location.href = ''; });
          linkoct = $('#oct > .mainImg > figure.pointer') 
          linkoct.on('click', function(){ location.href = ''; });
          linknov = $('#nov > .mainImg > figure.pointer') 
          linknov.on('click', function(){ location.href = ''; });
          linkdec = $('#dec > .mainImg > figure.pointer') 
          linkdec.on('click', function(){ location.href = ''; });


        }
      });
    });
  /***** /timer *****/

  /***** zoom *****/
    $(document).ready(function(){
      $('.mainImg > figure > a').zoom();
      $('.mainImg > figure').zoom();
    });
  /***** /zoom *****/
/********** /12Tshirts **********/